module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGamesJoined/nba/new_survive-7c6123d38b2b9e5b42fe2f11e1ea4274.svg";